import React from 'react';

import { Vertical } from 'utils/vertical';

type Context = {
  domain: string;
  vertical: Vertical;
};

export const VerticalContext = React.createContext<Partial<Context>>({});

type Props = {
  domain: string;
  vertical: Vertical;
  children: React.ReactNode;
};

const VerticalProvider = ({ domain, vertical, children }: Props) => {
  return <VerticalContext.Provider value={{ domain, vertical }}>{children}</VerticalContext.Provider>;
};

export default VerticalProvider;
